export default "__VITE_ASSET__D20gkUyM__"